import { z } from 'zod';
export const copilotSessionsListQuerySchema = z.object({
    project_id: z.string().uuid(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const copilotChatBodySchema = z.object({
    project_id: z.string().uuid(),
    session_id: z.string().uuid().optional(),
    message: z.string().trim().min(1).max(8000),
});
export const copilotSessionCreateSchema = z.object({
    project_id: z.string().uuid(),
    title: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=copilot.js.map